import { render } from "./PeerReviewReport.vue?vue&type=template&id=ef822cb2&scoped=true"
import script from "./PeerReviewReport.vue?vue&type=script&lang=js"
export * from "./PeerReviewReport.vue?vue&type=script&lang=js"

import "./PeerReviewReport.vue?vue&type=style&index=0&id=ef822cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef822cb2"]])

export default __exports__